import * as React from 'react';
import styled from 'styled-components';
import {
  ISlidingDateRangeTypeOption,
  slidingDateRangeProvider,
} from '../../../../data/providers/settings/dates/slidingDateRangeProvider';
import { IRange } from '../../../../data/types';
import { Column } from '../../../layout/Column';
import { ControlSpacer } from '../ControlSpacer';
import { Select } from '../Select';
import { TimeframeSelect } from './TimeframeSelect';

interface IProps {
  label?: string;
  dateRangeType: ISlidingDateRangeTypeOption;
  dateRange: IRange;
  disallowCustomRange?: boolean;
  disallowLastSession?: boolean;
  disallowAllTime?: boolean;
  onChange: (type: ISlidingDateRangeTypeOption, dateRange: IRange) => void;
}

export const SlidingDateRangeSelect = (props: IProps): React.ReactElement => {
  /**
   * @description handles change to date type
   * @param opt
   */
  const handleTypeChange = (opt: ISlidingDateRangeTypeOption): void => {
    props.onChange(opt, props.dateRange);
  };

  /**
   * @description handle date range change
   * @param selectedDates
   */
  const handleDateChange = (range: IRange): void => {
    props.onChange(props.dateRangeType, range);
  };

  const dateRangeOptions = React.useMemo((): ISlidingDateRangeTypeOption[] => {
    const { disallowCustomRange, disallowLastSession, disallowAllTime } = props;
    return slidingDateRangeProvider({
      disallowCustomRange,
      disallowLastSession,
      disallowAllTime,
    });
  }, [props.disallowCustomRange, props.disallowLastSession]);

  return (
    <Column>
      <ControlSpacer>
        <ControlLabel>{props.label ? props.label : 'Date Range'}</ControlLabel>
        <Select
          value={props.dateRangeType}
          options={dateRangeOptions}
          onChange={handleTypeChange}
          menuPlacement='auto'
        />
      </ControlSpacer>
      {!props.disallowCustomRange &&
        props?.dateRangeType?.value === 'custom' && (
          <TimeframeSelect
            onChange={handleDateChange}
            dateRange={props.dateRange}
          />
        )}
    </Column>
  );
};

const ControlLabel = styled.div`
  padding-bottom: 5px;
`;
